import { JSX, useContext } from "react"
import { ImpactProviderMapResults } from "@app/projects/results/common/mapping"
import { useProviderGapStatusDecorator, ProviderGapStatus } from "@app/shared/providers/utils"
import ProviderNetworkTypeBadge from "@app/shared/ProviderNetworkTypeBadge"
import { ProviderCard } from "@app/projects/network-assessment/maps/network-coverage-map/components/ProviderCard"
import {
  IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_DANGER,
  IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_SUCCESS,
  IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_WARNING,
  IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_DANGER,
  IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_SUCCESS,
  IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_WARNING
} from "@app/projects/network-assessment/maps/network-coverage-map/NetworkCoverageMapsConstants"
import { CountyProjectContext } from "@app/projects/CountyProjectContext"
import { ProviderCardProps } from "@app/projects/network-assessment/maps/network-coverage-map/interfaces"
import { ProviderBadgeStyle } from "@app/projects/enumerators";
import ProviderActionStatusBadge from "@app/shared/ProviderActionStatusBadge";

export const ImpactProviderCard = (
  { isSelected, passPercentage, provider, onClick }: ProviderCardProps
): JSX.Element => {

  const projectContext = useContext(CountyProjectContext);
  const getProviderGapStatusDecorator = useProviderGapStatusDecorator();

  const isProjectionVisible = projectContext.runConfiguration?.isLatestPublished || !projectContext.runConfiguration?.datePublished;

  const gapStatusDecorator = getProviderGapStatusDecorator(
    (provider as ImpactProviderMapResults).gainsPercent,
    (provider as ImpactProviderMapResults).impactsPercent,
    provider.servesPercent,
    passPercentage,
  )

  let highlightedStyles = {};

  if (isSelected) {
    if (gapStatusDecorator == ProviderGapStatus.Success) {
      highlightedStyles = {
        backgroundColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_SUCCESS,
        borderColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_SUCCESS,
        borderStyle: 'solid',
        borderWidth: '3px'
      };
    } else if (gapStatusDecorator == ProviderGapStatus.Warning) {
      highlightedStyles = {
        backgroundColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_WARNING,
        borderColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_WARNING,
        borderStyle: 'solid',
        borderWidth: '3px'
      };
    } else if (gapStatusDecorator == ProviderGapStatus.Danger) {
      highlightedStyles = {
        backgroundColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_DANGER,
        borderColor: IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_DANGER,
        borderStyle: 'solid',
        borderWidth: '3px'
      };
    }
  }

  return (
    <ProviderCard containerClassName={`${gapStatusDecorator}`} highlightedStyles={highlightedStyles} isSelected={isSelected} provider={provider} onClick={onClick}>
      <div className="d-flex flex-row">
        <p className="me-3"><strong>Serves:</strong> {provider.servesPercent}%</p>
        <p className="me-3"><strong>Gains:</strong> {(provider as ImpactProviderMapResults).gainsPercent}%</p>
        <p><strong>Impacts:</strong> {(provider as ImpactProviderMapResults).impactsPercent}%</p>
      </div>
      <div className="d-flex flex-row">
        <div className="me-2">
          <ProviderNetworkTypeBadge badgeStyle={ProviderBadgeStyle.Outline} providerNetworkType={provider.providerNetworkType} />
        </div>
        {isProjectionVisible && (
          <ProviderActionStatusBadge
            badgeStyle={ProviderBadgeStyle.Outline}
            status={provider.scenarioModelProviderStatus}
            hideWhenNullActionStatus={true}
          />
        )}
      </div>
    </ProviderCard>
  )
}